// Module
var code = "<div class=\"panelContainer\" class=\"box containerV\"> <div id=\"dxGrid\"></div> </div> <style>#main{background-color:grey}</style> ";
// Exports
module.exports = code;